import { getEmbeddedJson } from '@/utils/getEmbeddedJson';
import { JsonScriptId } from '@/constants';
import { useAuthLinks } from '@/hooks/useAuthLinks';
import { useBreadcrumb } from '@/hooks/useBreadcrumb';
import { useComponentFactory } from '@/hooks/useComponentFactory';
import { useMenuToggle } from '@/hooks/useMenuToggle';
import { useMiniBasket } from '@/hooks/useMiniBasket';
import { useNewsletterSignup } from '@/hooks/useNewsletterSignup';
import { useProductPurchasing } from '@/hooks/useProductPurchasing';
import type { MyAccountData } from '@/components/MyAccount/MyAccount.types';
import {
  DashboardPage,
  AddressesPage,
  ProfilePage,
  PaymentOptionsPage,
  GiftCardsPage,
} from '@/components/MyAccount';

const AccountPage = () => {
  const data: MyAccountData = getEmbeddedJson(JsonScriptId.MyAccount);

  switch (data.pageType) {
    case 'dashboard':
      return <DashboardPage data={data} />;
    case 'addresses':
      return <AddressesPage data={data} />;
    case 'profile':
      return <ProfilePage data={data} />;
    case 'paymentOptions':
      return <PaymentOptionsPage data={data} />;
    case 'giftCards':
      return <GiftCardsPage data={data} />;
    default:
      return null;
  }
};

export const MyAccountApp = () => {
  const authLinks = useAuthLinks();
  const menuToggle = useMenuToggle();
  const miniBasket = useMiniBasket();
  const breadcrumb = useBreadcrumb();
  const purchaseOptions = useProductPurchasing();
  const componentFactory = useComponentFactory();
  const newsletterSignup = useNewsletterSignup();

  return (
    <>
      <AccountPage />
      {authLinks}
      {menuToggle}
      {miniBasket}
      {breadcrumb}
      {purchaseOptions}
      {componentFactory}
      {newsletterSignup}
    </>
  );
};
